import Axios from "axios";
import { createModel } from "nyax";
import { Template, TemplateCreationData } from "src/models/understanding";
import { TemplateEntityModel } from "src/store/models/entity/understandingTemplate/entity";
import { TemplateListModel } from "src/store/models/entity/understandingTemplate/list";
import { createHelperModel } from "src/store/models/entity/_shared";

export const TemplateHelperModel = createModel(
  class extends createHelperModel<Template>({
    setItems: (getContainer, items) =>
      getContainer(TemplateEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(TemplateEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(TemplateEntityModel).state.byId[id],
    refreshList: (getContainer) =>
      getContainer(TemplateListModel).actions.refresh.dispatch({}),
  }) {
    public effects() {
      return {
        ...super.effects(),

        readById: async (payload: { id: string; force?: boolean }) => {
          const { id, force } = payload;
          return await this._readById({
            id,
            getByIdAction: async () => {
              const template =
                await this.dependencies.serviceClient.understanding.getById(id);

              return template;
            },
            force,
          });
        },
        create: async (payload: {
          template: TemplateCreationData;
          file: File;
        }) => {
          const { file, template } = payload;

          return await this._create({
            createAction: async () => {
              const newTemplate =
                await this.dependencies.serviceClient.understanding.create(
                  template
                );

              if (!newTemplate.uploadUri) {
                throw new Error("upload uri is not exist");
              }
              delete Axios.defaults.headers.put["Content-Type"];
              await Axios({
                method: "PUT",
                headers: newTemplate.uploadUri.headers,
                url: newTemplate.uploadUri.uri,
                data: file,
              });
              try {
                await this.dependencies.serviceClient.understanding.patch(
                  newTemplate.id
                );
                return newTemplate;
              } catch (e) {
                const error = e as
                  | { response: { data: { code: string } } }
                  | undefined;
                if (error?.response) {
                  const { code } = error?.response.data;
                  if (code === "InvalidPdfDocument") {
                    await this.actions.delete.dispatch({
                      id: newTemplate.id,
                    });
                  }
                }
              }
              return Promise.reject(false);
            },
          });
        },
        update: async (payload: {
          template: Partial<Template> & Pick<Template, "id">;
        }) => {
          const { template } = payload;
          return await this._update({
            id: template.id,
            updateAction: () =>
              this.dependencies.serviceClient.understanding.update(template),
          });
        },
        publish: async (payload: { id: string; isPublished: boolean }) => {
          const { id, isPublished } = payload;
          return await this._update({
            id,
            updateAction: () =>
              this.dependencies.serviceClient.understanding.publish(
                id,
                isPublished
              ),
          });
        },
        delete: async (payload: { id: string }) => {
          const { id } = payload;
          return await this._delete({
            id: id,
            deleteAction: () =>
              this.dependencies.serviceClient.understanding.delete(id),
          });
        },
      };
    }
  }
);
